import HeaderHero from "./HeaderHero";
import JotFormComponent from "../../components/form/JotFormEmbed";
import "./EnrollPage.scss";
import React from "react";

function EnrollPage() {
	React.useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<>
			<div>
				<HeaderHero
					title="JLR ENROLLMENT 2026"
					subtitle="Select media programs, then complete dealer information."
					trailingText="Digital co-op enrollment"
				/>
				<div className="enroll-page">
					<JotFormComponent />
				</div>
			</div>
		</>
	);
}

export default EnrollPage;
